// extracted by mini-css-extract-plugin
module.exports = {"fields":"_1W5Ak6","fields__row":"_19ZWPk","fields__item":"_3tzH-O","fields__delim":"_2Dq_S1","swap":"_1AaTBw","singleField":"_1hfbpi","placeDisplay":"_1AFLU8"};